<app-poi-sync type="vehicles-groups" *ngIf="vehicleG" [id]="vehicleG.id"></app-poi-sync>
